import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import TripView from "pages/TripView/TripView";
import LandingPage from "pages/LandingPage/LandingPage";
import Blogs from "pages/Blogs/Blogs";
import Users from "pages/Users/Users";
import TripList from "components/TripList/TripList";
import Login from "pages/Login/Login";
import SocialLogin from "components/SocialLogin";
import ProtectedRoute from "components/ProtectedRoute";
import Dashboard from "components/Dashboard";
import AdminLayout from "components/AdminLayout";
import PrivacyPolicy from "components/PrivacyPolicy";

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/trip/:tripId" element={<TripView />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      {/* <Route path="/blogs" element={<Blogs />} />
      <Route path="/users" element={<Users />} /> */}

      <Route path="/users" element={<AdminLayout children={<Users />} />} />
      <Route path="/trips" element={<AdminLayout children={<TripList />} />} />
      <Route path="/blogs" element={<AdminLayout children={<Blogs />} />} />

      {/* <Route path="/" element={<SocialLogin />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" />} /> */}
    </Routes>
  );
};

export default AppRoutes;
